var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("appsize-" + _vm.$mq),attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('main-app'):_vm._e(),(!_vm.isLoggedIn)?_c('div',{attrs:{"id":"loginwrap"}},[_c('login')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }